var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10584 24.1061C7.82454 24.3874 7.6665 24.7689 7.6665 25.1667C7.6665 25.5646 7.82454 25.9461 8.10584 26.2274C8.38715 26.5087 8.76868 26.6667 9.1665 26.6667H24.1665C24.5643 26.6667 24.9459 26.5087 25.2272 26.2274C25.5085 25.9461 25.6665 25.5646 25.6665 25.1667C25.6665 24.7689 25.5085 24.3874 25.2272 24.1061C24.9459 23.8248 24.5643 23.6667 24.1665 23.6667H9.1665C8.76868 23.6667 8.38715 23.8248 8.10584 24.1061Z",
    fill: "#7889B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.10584 30.1061C8.38715 29.8248 8.76868 29.6667 9.1665 29.6667H16.6665C17.0643 29.6667 17.4459 29.8248 17.7272 30.1061C18.0085 30.3874 18.1665 30.7689 18.1665 31.1667C18.1665 31.5646 18.0085 31.9461 17.7272 32.2274C17.4459 32.5087 17.0643 32.6667 16.6665 32.6667H9.1665C8.76868 32.6667 8.38715 32.5087 8.10584 32.2274C7.82454 31.9461 7.6665 31.5646 7.6665 31.1667C7.6665 30.7689 7.82454 30.3874 8.10584 30.1061Z",
    fill: "#7889B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 3.75C2.1 2.5631 3.06221 1.6 4.25 1.6H11C12.5648 1.6 14.0655 2.22161 15.1719 3.32807C16.2784 4.43453 16.9 5.93522 16.9 7.5V11.25C16.9 12.6689 17.4637 14.0297 18.467 15.033C19.4703 16.0363 20.8311 16.6 22.25 16.6H26C27.5648 16.6 29.0655 17.2216 30.1719 18.3281C31.2784 19.4345 31.9 20.9352 31.9 22.5V38.25C31.9 39.4363 30.9363 40.4 29.75 40.4H4.25C3.06366 40.4 2.1 39.4363 2.1 38.25V3.75Z",
    stroke: "#7889B3",
    strokeWidth: 3.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9419 0.63208C20.5949 2.53801 21.5034 4.97717 21.4999 7.50008V11.2501C21.4999 11.6641 21.8359 12.0001 22.2499 12.0001H25.9999C28.5228 11.9966 30.962 12.905 32.8679 14.5581C31.988 11.2115 30.2349 8.15868 27.7881 5.71185C25.3413 3.26503 22.2885 1.51201 18.9419 0.63208Z",
    fill: "#3B72FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.8c8bee11c26a3960a7c3649cc9a29908.svg";
export { ForwardRef as ReactComponent };